import { useSelector } from 'react-redux';

import { getCampaignEditorLink } from 'utils/appRoutes';

import { getExperimentHeaderMetadata } from 'modules/experiments/ducks/selectors';
import { iconSize } from 'modules/experiments/constants';
import { useExperimentsTranslations } from 'modules/experiments/hooks';

import { BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES } from 'modules/campaignIndex/constants';
import {
  CAMPAIGN_TYPE_CONTENT_MAPPER,
  MESSAGE_MEDIUM_CONTENT_MAPPER,
} from 'modules/campaigns/lib/utils';

import { Badge } from 'ui/badge';
import { Popover } from 'ui/popover';

import {
  PopoverRow,
  CampaignLink,
  StyledPopoverContent,
  StyledTrigger,
  IconWrapper,
} from './Styled';
import { PrimaryDetail } from '../Styled';

type CampaignPopoverProps = {
  open: boolean;
};

export const CampaignPopover = ({ open }: CampaignPopoverProps) => {
  const { campaignState, messageMedium, campaignType, campaignName, campaignId } = useSelector(
    getExperimentHeaderMetadata,
  );

  const { t } = useExperimentsTranslations();

  // Campaign State
  const campaignVariant = BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES[campaignState];

  // Message Medium
  const { Icon: MessageIcon, displayName: messageDisplayName } =
    MESSAGE_MEDIUM_CONTENT_MAPPER[messageMedium] || {};

  // Campaign Type
  const { Icon: CampaignTypeIcon, displayName: campaignDisplayName } =
    CAMPAIGN_TYPE_CONTENT_MAPPER[campaignType] || {};

  // Campaign Link
  const goToCampaignReviewPage = () => {
    window.location.href = getCampaignEditorLink(campaignId, campaignState);
  };

  return (
    <Popover open={open}>
      <StyledPopoverContent
        TitleContent={campaignName}
        side="right"
        data-test="experiment-campaign-info-popover-content"
      >
        <PopoverRow>
          <PrimaryDetail>
            <Badge variant={campaignVariant}>{campaignState}</Badge>
          </PrimaryDetail>
          <PrimaryDetail>{`${t('header.tooltip.campaignId')}: ${campaignId}`}</PrimaryDetail>
        </PopoverRow>
        <PopoverRow>
          <PrimaryDetail>
            <IconWrapper>
              <MessageIcon {...iconSize} />
            </IconWrapper>
            {messageDisplayName}
          </PrimaryDetail>
          <PrimaryDetail>
            <IconWrapper>
              <CampaignTypeIcon {...iconSize} />
            </IconWrapper>
            {campaignDisplayName}
          </PrimaryDetail>
        </PopoverRow>
        <PopoverRow>
          <CampaignLink onClick={goToCampaignReviewPage}>
            {t('header.tooltip.campaignLink')}
          </CampaignLink>
        </PopoverRow>
      </StyledPopoverContent>
      <StyledTrigger asChild>
        <div>{` ${campaignName}`}</div>
      </StyledTrigger>
    </Popover>
  );
};
